/**
 * Voice Practice feature flag.
 *
 * A plain per-environment switch, read from the generated public config
 * (`environments/<env>/public.yaml` → `features.voicePractice`). It used to be
 * `EXPO_PUBLIC_VOICE_ENABLED`, which lived only in a gitignored `.env.local` —
 * so local dev had voice and every CI-built binary silently baked `false`
 * (found 2026-08-20 when stg mobile shipped without voice). The config route is
 * the one the workflows already generate and validate per environment, so the
 * value now exists everywhere a build does. Deliberately NOT gated on
 * `__DEV__`: dev / staging / prod behave identically — the only difference is
 * the yaml value.
 *
 * This flag is the master on/off only. Whether voice actually appears is ANDed
 * with platform CAPABILITY (a confirmed on-device recogniser; fail closed to
 * text), and usability follows the SAME reply-balance gate as text — voice is not
 * a separate Plus entitlement (a user with replies left can use it even if Plus
 * lapsed; a user out of replies can't send text OR voice).
 *
 * A live, DB-backed flag for runtime toggling without a redeploy is the Phase E
 * upgrade — swap this read for that one and the call sites don't change.
 */
import { publicConfig } from "@/config/public";

export const VOICE_ENABLED: boolean = publicConfig.features.voicePractice;
